import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatOption } from '@angular/material/core';
import { Language } from '@models/profile/language';
import { LanguageEnum } from '@models/profile/language.enum';
import { ProficiencyEnum } from '@models/profile/proficiency.enum';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'profile-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageComponent implements AfterViewInit, OnInit {
  @Input() model: Language;
  @Input() loading: boolean;
  @Input() excludes: Language[];

  @ViewChildren('option') languageOptions: QueryList<MatOption>;

  languages$: Observable<LanguageEnum[]> = of(Object.values(LanguageEnum));
  translatedLanguages: { [prop in LanguageEnum]?: string } = {};
  filteredLanguages$: Observable<LanguageEnum[]>;
  proficiencies: string[] = Object.values(ProficiencyEnum);

  ngOnInit(): void {
    this.filteredLanguages$ = this.languages$;
  }

  ngAfterViewInit(): void {
    this.excludes = this.excludes.filter((item) => item.name !== this.model.name);

    this.translatedLanguages = this.languageOptions
      .map((option) => ({ value: option.value, viewValue: option.viewValue }))
      .reduce((bucket, item) => {
        bucket[item.value] = item.viewValue;
        return bucket;
      }, this.translatedLanguages);
  }

  displayLanguage(): (_: LanguageEnum) => string {
    return (language: LanguageEnum) => this.translatedLanguages[language];
  }

  trackByLanguage(_: any, language: LanguageEnum): string {
    return language;
  }

  trackByLevel(_: any, level: ProficiencyEnum): string {
    return level;
  }
}
